export const environment = {
  production: false,
  teamInboxMessageWindowEnabled: false,
  teamInboxPerformanceDiagnostics: false,
  defaultLang: "fr",
  // Master switch for the in-app feature guide / onboarding tours (driver.js spotlight
  // walkthroughs). Off by default on every page/environment until the backend-managed
  // guide system replaces the hardcoded ONBOARDING_TOURS config.
  featureGuideEnabled: true,
  // Never true outside environment.local.ts — see that file for why this
  // exists at all. Phone verification stays mandatory for every real client.
  allowPhoneSkipForTesting: false,
  keycloak: {
    url: "https://keycloak.dashypay.com",
    realm: "mvp-dashy",
    clientId: "backoffice",
  },
  studioUrl: "https://devstudio.dashypay.com/",
  // clarityProjectId: "rn0l1k5u2h",
  defaultDashyCompanyId: "DSH01",
  backofficeUrl: "https://backoffice.dashypay.com/",
  // Public status page: on these hostnames the app serves only the status page at "/".
  statusHosts: ["statusdev.dashypay.com"] as string[],
  backofficeMobileUrl: "https://pwa-dev.dashypay.com/",
  inAppBaseUrl: "https://inapp.dashypay.com",
  erpApiUrl: "https://dev.dashypay.com/erp-api",
  coreApiUrl: "https://dev.dashypay.com/core-api",
  wabaApiUrl: "https://dev.dashypay.com/waba-api",
  wabaBotApiUrl: "https://dev.dashypay.com/waba-api",
  paymentApiUrl: "https://dev.dashypay.com/payment-api",
  // Where Dashy sends Odoo events (n8n). Clients never see or type it: the Odoo integration
  // sets it on every Odoo connection. Prod and dev share one n8n host, the path separates them.
  odooEventsUrl: "https://n8n.srv1896229.hstgr.cloud/webhook/dev/dashy-order",
  compSecretKey: "de8243df96a9e898",
  plkCustomisedAppearance: true,
  googleMapsApiKey: "AIzaSyDIurzixvO04Kc2C7m3FXS0a0iLGa5NlrM",
  firebase: {
    apiKey: "AIzaSyB1Uoc3t5wKjYFC-MFJbSHOn_YKAifKn2s",
    authDomain: "dashy-bb179.firebaseapp.com",
    projectId: "dashy-bb179",
    storageBucket: "dashy-bb179.firebasestorage.app",
    messagingSenderId: "999456120351",
    appId: "1:999456120351:web:b62a59b0e9d219b68ebf2a",
  },
  // "Continue with Google / Facebook" on the sign-up page. waba re-checks every
  // token against these same ids (Google: id_token "aud", Facebook: debug_token
  // app_id), so the two sides must stay in step or every sign-in is rejected.
  social: {
    google: {
      // OAuth 2.0 "Web application" client ID from the Google Cloud console.
      // Same client as environment.local.ts — backoffice.dashypay.com is
      // already an Authorised JavaScript origin on it.
      clientId:
        "388465639539-7s6cmfld8d74lf0im7tgtlg1gd20l4qo.apps.googleusercontent.com",
    },
    facebook: {
      appId: "532395029698625",
      sdkVersion: "v21.0",
      // Facebook Login for Business config: "dashy sign up" — General, User
      // access token, email + whatsapp_business_management. Dedicated to
      // sign-up/login; do not point this at "Dashypay Instagram" (a different
      // config on the same app, used for Instagram business-asset connection).
      configId: "2347780152424220",
    },
  },
  meta: {
    appId: "532395029698625",
    sdkVersion: "v21.0",
    signup: {
      configId: "1106303334484141",
      responseType: "code",
      featureType: "whatsapp_business_app_onboarding",
      sessionInfoVersion: "3",
      // BIK BSP Multi-Partner Solution "BIK - BSP" (Dashy = Solution Owner). Empty = Dashy only (card billing).
      solutionId: "872544745817854",
    },
    catalogSignup: {
      configId: "1106303334484141", //To verify on DashyPay https://developers.facebook.com/
      responseType: "code",
      featureType: "whatsapp_business_app_onboarding",
      sessionInfoVersion: "3",
      // BIK BSP Multi-Partner Solution "BIK - BSP" (Dashy = Solution Owner). Empty = Dashy only (card billing).
      solutionId: "872544745817854",
    },
    webhookCallbackUrl:
      "https://dev.dashypay.com/waba-api/v1/meta-waba/webhook",
  },
};
